import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  console.log('[ProtectedRoute] isAuthenticated:', isAuthenticated, 'loading:', loading);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>در حال بارگذاری...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('[ProtectedRoute] Redirecting to /');
    return <Navigate to="/" replace />;
  }

  console.log('[ProtectedRoute] Rendering children');
  return children;
}

export default ProtectedRoute;